webpackJsonp([81],{

/***/ 1529:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(837);


/***/ }),

/***/ 837:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(145);

var _datetime2 = _interopRequireDefault(_datetime);

var _en = __webpack_require__(646);

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en', _en2.default);

/***/ })

},[1529]);


// WEBPACK FOOTER //
// app/datetime.en-9a74c8bb6f67a1f0a8ff.js